import { Box, Button, Center, Flex, FormControl, FormLabel, Heading, Hide, IconButton, Progress, Radio, RadioGroup, Select, Show, Stack, Stat, StatHelpText, StatLabel, StatNumber, useBreakpointValue, useDisclosure } from '@chakra-ui/react';
import { Canvas } from '@react-three/fiber';
import React, { useState, Suspense, useEffect, useCallback } from 'react';
import Frame from '../components/Frame';

import GridHelper from '../components/GridHelper'
import { useProgress } from '@react-three/drei';
import { useMesh } from '../hooks/spine';
import PreloadAssets from '../loader/PreloadAssets';
import Damsel from '../components/Damsel';
import { debug } from '../config';
import { PointAttachment, SkeletonMesh, Skin } from '@esotericsoftware/spine-threejs';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { useKeyPhrase, useKeyPress } from '../hooks/keyboard';
import DevModal from '../components/DevModal';
import { useAtomValue } from 'jotai';
import { moneyAtom } from '../store/game';
import { useDevMenuControls } from '../hooks/dev';


const isStateAnimation = (name: string) => /^is[A-Z]/.test(name)
const transformAnimationName = (name: string) => name.replace(/-/g, ' ').replace(/(\d)/, ' $1')

const bodySkinRegex = /^body\/(\w+)\/(\w+)/

const isBodySkin = (skin: Skin) => bodySkinRegex.test(skin.name)
const transformSkinName = (name: string) => name.match(bodySkinRegex)?.[2] || ''

const createSkinMapNames = (skins: Skin[]) => {

  const map = skins.reduce((acc, skin) => {
    if(skin.name === 'default') {
      return acc
    }
    const [cat, type, skinName] = skin.name.split('/')
    if(!cat || !type || !skinName || isBodySkin(skin)) {
      return acc
    }
    if(acc[cat]) {
      if(acc[cat][type]) {
        acc[cat][type] = [...acc[cat][type], skinName]
      } else {
        acc[cat][type] = [skinName]
      }
    } else {
      acc[cat] = { [type]: [skinName] }
    }
    return acc
  }, {} as Record<string, Record<string, string[]>>)

  return Object.keys(map).map(key => ({
    category: key,
    types: Object.keys(map[key]).map(type => ({
      type: type,
      skins: map[key][type]
    }))
  }))

}

function SkinControls({mesh, onChange}: { mesh: SkeletonMesh, onChange: () => void }) {

  const skinMap = createSkinMapNames(mesh.skeleton.data.skins)

  
  return <>
  {skinMap.map(({category, types}) => {

return (<Box key={category}>
  <>
    <FormLabel textTransform="capitalize">{category}</FormLabel>
    {types.map(({type, skins}) => {
          return (<FormControl key={type} mb={2}>
            <FormLabel textTransform="capitalize" fontSize="sm">{type}</FormLabel>
            <Select data-type={type} name={`${category}/${type}`} onChange={e => {



              onChange()
            }}>
              <option value="">(none)</option>
              {skins.map(a => <option key={a} value={a}>{a}</option>)}
          </Select>
      </FormControl>)
    })}
  </>
  </Box>)
  })
}
  </>
  
  



}

function GameInfo() {
  const money = useAtomValue(moneyAtom)

  return <Box position="absolute" bottom={2} left={2}>
    <Stat>
    <StatLabel>Balance</StatLabel>
      <StatNumber>${money.toFixed(2)}</StatNumber>
    </Stat>
  </Box>
}


function TestBed() {

  const [anim, setAnim] = useState('isIdle')
  const [damsel, setDamsel] = useState('heather')

  const [open, setOpen] = useState([true, true])
  const onToggleMenu = (index: number) => setOpen(r => [index === 0 ? !r[0] : r[0], index === 1 ? !r[1] : r[1]])
  
  const mq = useBreakpointValue({ base: true, lg: false })

  useEffect(() => {
    setOpen([!mq, !mq])
  }, [mq])

  const mesh = useMesh('damsel')
  
  const onAnimationButtonClick = (name: string) => () => {
    //raptor.state.data.setMix("walk", "jump", 0.1)
    mesh.state.addAnimation(1, name, false)
  }
  const onAnimationSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const name = e.target.value
    setAnim(name)
    mesh.state.setAnimation(0, name, true)
  }

  const recalculateAccessories = useCallback(() => {
      const selects = document.querySelectorAll<HTMLSelectElement>('select[data-type]')
      const newSkin = mesh.skeleton.skin;
      const baseSkin = mesh.skeleton.data.findSkin(`body/damsel/${damsel}`)

      if(!newSkin) {
        return
      }

      selects.forEach(select => {
        
        const name = select.name
        const skinName = select.value

        const skins = mesh.skeleton.data.skins.filter(s => s.name.includes(name))

        if(skinName) {
          const accessorySkin = mesh.skeleton.data.findSkin(`${name}/${skinName}`)

          skins.filter(s => !s.name.includes(skinName)).forEach(s => {
            //.filter(a => !(a.attachment instanceof PointAttachment)) removed
            s.getAttachments().forEach(a => {
              newSkin.removeAttachment(a.slotIndex, a.name)
            })
          })
          
          accessorySkin && newSkin.addSkin(accessorySkin)


        } else {

          skins.forEach(s => {
            s.getAttachments().forEach(a => {
              newSkin.removeAttachment(a.slotIndex, a.name)
              if(a.attachment instanceof PointAttachment) {
                const newAttach = baseSkin?.getAttachment(a.slotIndex, a.name)
                newAttach && newSkin.setAttachment(a.slotIndex, a.name, newAttach)
              }
            })
          })
        }
      })
    
      mesh.skeleton.setSkin(newSkin);
      mesh.skeleton.setSlotsToSetupPose();
      mesh.state.apply(mesh.skeleton)
  
      
  
  }, [mesh, damsel])

  const { onOpen } = useDevMenuControls()

  useKeyPhrase('dev', onOpen)
  
  return (<Frame>
    <GameInfo />
    <Canvas camera={{position: [0,0,10]}} orthographic>
      <GridHelper />
      <Damsel mesh={mesh} name={damsel} onDamselChange={recalculateAccessories} />
    </Canvas>
    <DevModal />
    <Stack bg="#fff" position="absolute" top={2} left={open[0] ? 2 : '-8.75rem'} transition="left 0.33s" p={2} borderWidth={1} borderRadius="xl" spacing={5}>
                
      <FormControl>
        <FormLabel htmlFor='anim'>State</FormLabel>
        <Select id='anim' onChange={onAnimationSelectChange}>
          {mesh?.skeleton?.data?.animations.filter(a => isStateAnimation(a.name)).map(a => <option key={a.name} value={a.name}>{a.name}</option>)}
        </Select>
      </FormControl>

      <FormControl>
        <FormLabel>Damsel</FormLabel>
        <Stack>
          <RadioGroup display="flex" flexDir="column" value={damsel} textTransform="capitalize" onChange={setDamsel}>
            {mesh?.skeleton?.data?.skins.filter(isBodySkin).map(a => <Radio key={a.name} value={transformSkinName(a.name)}>{transformSkinName(a.name)}</Radio>)}
          </RadioGroup>
        </Stack>
      </FormControl>

      <FormControl>
        <FormLabel>Animation</FormLabel>
        {mesh?.skeleton?.data?.animations.filter(a => !isStateAnimation(a.name)).map(a => <Button display="block" textTransform="capitalize" w="100%" mb={2} onClick={onAnimationButtonClick(a.name)} key={a.name}>{transformAnimationName(a.name)}</Button>)}
      </FormControl>



      <Show below="lg">
        <IconButton
          top={0}
          borderTopLeftRadius={0}
          borderBottomLeftRadius={0}
          aria-label="hide menu"
          size="sm"
          fontSize="xl"
          icon={open[0] ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          colorScheme="blue"
          position="absolute"
          left={'calc(100% + 1px)'}
          onClick={() => onToggleMenu(0)}
        />
      </Show>

    </Stack>

    <Stack maxHeight="calc(100% - 2*var(--chakra-space-2))" bg="#fff" position="absolute" top={2} right={open[1] ? 2 : '-10rem'} transition="right 0.33s" p={2} borderWidth={1} borderRadius="xl" spacing={5}>
      <Box overflowY="auto" height="100%">
        <SkinControls onChange={recalculateAccessories} mesh={mesh} />
      </Box>

      <Show below="lg">
        <IconButton
          top={0}
          borderTopRightRadius={0}
          borderBottomRightRadius={0}
          aria-label="hide menu"
          size="sm"
          fontSize="xl"
          icon={open[1] ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          colorScheme="blue"
          position="absolute"
          right={'calc(100% + 1px)'}
          onClick={() => onToggleMenu(1)}
        />
      </Show>


    </Stack>

              

  </Frame>)
}

function Loading() {
  const p = useProgress()
  if(debug) {
    console.log('Loading... ' + p.progress)
  }
  return <Progress value={p.progress} />
}


function WrappedTestBed() {
  return (<Suspense fallback={<Loading />}>
    <PreloadAssets />
    <TestBed />
  </Suspense>)
}

export default WrappedTestBed